import styled from "styled-components";
import { Menu as AntMenu } from "antd";

export const Menu = styled(AntMenu)``;
